import { Box, Inscription } from '@common-fe/common-fe';
import styled from 'styled-components';

export const EllipsisText = styled(Inscription)<{ width?: string }>`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const TextWithPoint = styled(Box)`
  > span {
    position: relative;
    padding-left: 16px;
    &:before {
      content: '';
      width: 4px;
      height: 4px;
      background: black;
      position: absolute;
      left: 6px;
      top: calc(50% - 2px);
      border-radius: 50%;
    }
  }
`;

export const ServiceItemWrapper = styled(Box)`
  &:not(:first-child) {
    margin-top: ${({ theme }) => theme.spacings.spacing12};
  }
`;

export const IntersectionWrapper = styled(Box)`
  position: relative;
  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.border1};
  }
  > div {
    align-self: stretch;
    width: 22%;
    padding-top: ${({ theme }) => theme.spacings.spacing12};
    padding-bottom: ${({ theme }) => theme.spacings.spacing12};
    &:not(:first-child) {
      width: 39%;
      border-left: 1px solid ${({ theme }) => theme.colors.border1};
      padding-left: ${({ theme }) => theme.spacings.spacing12};
      &:not(:last-child) {
        padding-right: ${({ theme }) => theme.spacings.spacing12};
      }
    }
  }
`;

export const ShowAllWrap = styled(Box)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.border1};
  border-left: 1px solid ${({ theme }) => theme.colors.border1};
  border-right: 1px solid ${({ theme }) => theme.colors.border1};
`;

export const HeadersWrap = styled(Box)`
  > span {
    width: 39%;
    &:first-child {
      width: 22%;
    }
    &:not(:first-child) {
      padding-left: ${({ theme }) => theme.spacings.spacing12};
    }
  }
`;
